module.exports = __webpack_public_path__ + "static/media/proj18_img5.c2045d7a.jpg";